module.exports = __webpack_public_path__ + "static/media/icon_86.d044035d.svg";